var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneNotch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 28,
    viewBox: "0 0 136 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43164 0.957031H131.705V13.3205C131.705 21.059 125.432 27.3323 117.693 27.3323H18.4435C10.705 27.3323 4.43164 21.059 4.43164 13.3205V0.957031Z",
    fill: "#232020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6221 0.957015H0.500959V0.957033C2.68564 0.957044 4.45668 2.72808 4.45668 4.91277C4.45668 4.96817 4.45554 5.02331 4.45328 5.07816H4.6221V0.957015Z",
    fill: "#232020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.554 0.957015H135.675V0.957033C135.675 0.957033 135.675 0.957033 135.675 0.957033C133.49 0.957033 131.719 2.72808 131.719 4.91277C131.719 4.96817 131.72 5.02331 131.722 5.07816H131.554V0.957015Z",
    fill: "#232020"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.755,
    cy: 12.4962,
    r: 6.59382,
    fill: "#0F0E0E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNotch);
export default __webpack_public_path__ + "static/media/phone-notch.788d9b2d8467b9b720158b6d30318713.svg";
export { ForwardRef as ReactComponent };